function BrandLogo({ compact = false }) {
  return (
    <div className={`app-brand ${compact ? 'compact' : ''}`}>
      <div className="brand-mark">
        <img className="brand-image" src="/logo-1.png" alt="Barbellos logo" />
      </div>
      <div className="brand-text">
        <p className="brand-name">Barbellos</p>
        <p className="brand-tag">OS for your gym</p>
      </div>
    </div>
  );
}

export default BrandLogo;
